import {functions, ImageEditor} from "../imageEditor";
import {getMaterialIdByTitle} from "./materials";
import {fabric} from "fabric";

ImageEditor.prototype.save = function({callback}) {
    let app = this;
    let store = this.store;
    let canvas = this.store.canvas;

    captureCanvasToDom(canvas);

    getDataURL.bind(app)({canvas, callback: (img)=> {
        onImageLoaded({img});
    }});

    function onImageLoaded({img}) {
        scaleImage(img, 200, 200, function(thumb) {
            let canvasData = getCanvasData.bind(app)({canvas, store});
            let data = {
                canvasData: canvasData, //FABRICJS CANVAS DATA
                image: img,
                thumb: thumb,

                material_name: store.material.title,
                width: store.width,
                height: store.height,
                quantity: store.quantity,
                message: store.message,
                laminate: store.laminate,
                instruction: store.instruction,
                instruction_files: store.instruction_files,
                mask_type: store.mask_type,
                mask_data: JSON.stringify(store.maskData[store.mask_type]),
                bg_color: store.bg_color,
                id: store.cart_id,
            }

            // downloadDataURL(img);

            setTimeout(()=> {
                clearCapture();
            }, 2000);

            if (callback) {
                callback(data);
            }
        });
    }
};

function getDataURL({canvas, width = null, height = null, callback} = {}) {
    this.store.setLoading('processing.getDataURL', '');

    let oldWidth = canvas.getWidth();
    let oldHeight = canvas.getHeight();
    let oldViewportTransform = canvas.viewportTransform;

    let newWidth = this.store.width * 300; //300 dpi
    let newHeight = this.store.height * 300;

    newWidth = width ? width : newWidth;
    newHeight = height ? height : newHeight;

    this.changeCanvasSize({canvas, newWidth, newHeight})
    canvas.zoomToMask({store: this.store});
    this.refresh();

    let app = this;
    let onProcessFinished = ()=> {
        app.processingFinishedDelegate.unsubscribe(onProcessFinished);

        setTimeout(()=> {
            const dataURL = canvas.toDataURL({
                format: 'png',
                multiplier: 1
            });

            this.changeCanvasSize({canvas, newWidth: oldWidth, newHeight: oldHeight});
            this.refresh();

            canvas.viewportTransform = oldViewportTransform;
            canvas.requestRenderAll();

            if (callback) {
                callback(dataURL);
            }
        }, 1000);
    };
    this.processingFinishedDelegate.subscribe(onProcessFinished);
    this.store.setLoadingFinished('processing.getDataURL');
}

function getCanvasData({canvas, store}) {
    let oldWidth = canvas.getWidth();
    let oldHeight = canvas.getHeight();
    let oldViewportTransform = canvas.viewportTransform;

    let newWidth = store.width * 300; //300 dpi
    let newHeight = store.height * 300;

    this.changeCanvasSize({canvas, newWidth, newHeight})
    this.refresh();

    let canvasData = JSON.stringify(canvas.toJSON());

    this.changeCanvasSize({canvas, newWidth: oldWidth, newHeight: oldHeight});
    this.refresh();

    canvas.viewportTransform = oldViewportTransform;
    canvas.requestRenderAll();

    return canvasData;
}


function downloadCurrent() {
    let store = window.imageEditor.store;
    downloadDataURL(store.canvas.toDataURL());
}

window.download = downloadCurrent;

function downloadDataURL (dataURL) {
    const link = document.createElement('a');
    link.download = 'image.png';
    link.href = dataURL;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

ImageEditor.prototype.load = function(data, callback) {
    let app = this;
    let store = this.store;
    let canvas = this.store.canvas;

    captureCanvasToDom(canvas);

    this.store.setLoading('processing.load_canvas', '');

    let oldWidth = canvas.getWidth();
    let oldHeight = canvas.getHeight();
    this.changeCanvasSize({canvas, newWidth: data.width*300, newHeight: data.height*300});

    canvas.loadFromJSON(data.canvas_data, function() {
        app.changeCanvasSize({canvas, newWidth: oldWidth, newHeight: oldHeight});

        functions.setMaterial(getMaterialIdByTitle(data.material_name));
        functions.updateMask();

        store.width = data.width;
        store.height = data.height;
        store.quantity = data.quantity;
        store.message = data.message;
        store.laminate = data.laminate;
        store.instruction = data.instruction;
        store.instruction_files = data.instruction_files;
        store.mask_type = data.mask_type;
        store.cart_id = data.id;
        store.setMaskData(data.mask_type, JSON.parse(data.mask_data));
        canvas.zoomToMask({store:app.store, zoom: 0.6});
        store.bg_color = data.bg_color;

        app.refresh();

        setTimeout(()=> {
           app.refresh();

            if (callback) {
                callback();
            }

            app.store.setLoadingFinished('processing.load_canvas');
            clearCapture();

        }, 500);
    });

    return data;
};

fabric.Canvas.prototype.zoomToMask = function({store, zoom= 1}) {
    let canvas = this;
    // Reset zoom
    canvas.setZoom(1);

    // Reset pan
    canvas.viewportTransform[4] = canvas.width / 2;
    canvas.viewportTransform[5] = canvas.height / 2;

    // Define the point to zoom to, which is the center of the canvas
    const centerPoint = new fabric.Point(canvas.width / 2, canvas.height / 2);

    // Define the zoom level based on the dimensions you want to fit into view
    const zoomX = canvas.width / (store.width * 300);
    const zoomY = canvas.height / (store.height * 300);
    const zoomLevel = Math.min(zoomX, zoomY);

    // Perform the zoom
    canvas.zoomToPoint(centerPoint, zoomLevel * zoom);
};

function scaleImage(imgSrc, maxWidth, maxHeight, callback) {
    let img = new Image();
    img.src = imgSrc;

    img.onload = function() {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");

        let ratio = Math.min(maxWidth / img.width, maxHeight / img.height);

        canvas.width = img.width * ratio;
        canvas.height = img.height * ratio;

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        callback(canvas.toDataURL());
    };
}

//todo should make this global function/reactive
let capture_element;
export function captureCanvasToDom (canvas) {
    let imgData = canvas.toDataURL('image/png');
    let imgElement = $('<img>').attr('src', imgData);
    let imgWrapper = $('<div>').addClass('image-wrapper').append(imgElement);
    capture_element = imgWrapper;

    $('#canvas-wrapper').append(imgWrapper);

    $('.canvas-container').hide();

    $("body").append(`
      <div id="overlay" class="d-flex justify-content-center align-items-center gap-4">
        <div class="fs-2 fw-600" style="color: black">
            Loading...
        </div>
        <div class="spinner-border" role="status" style="color: black; font-size: 14px; font-weight: 400; width: 1.5rem; height: 1.5rem">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    `);

    $("#overlay").css({
        "position": "fixed",
        "top": 0,
        "left": 0,
        "width": "100%",
        "height": "100%",
        "background": "rgba(255,255,255,1)",
        "z-index": 1000
    });
}

export function clearCapture () {
    $('.canvas-container').show();
    $(capture_element).remove();

    $("#overlay").remove();
}
